import { useAddToast } from '../../../../../../contexts/ToastContext';
import type { ClaimLdapDomainRequest } from '../../../../../../../typings/api';
import { post } from '../../../../../../redux/api';

const useClaimLDAPDomain = (organizationId: number) => {
  const addToast = useAddToast();

  const claimLDAPDomain = (payload: ClaimLdapDomainRequest) => {
    try {
      return post<ClaimLdapDomainRequest, void>(`/api/organizations/${organizationId}/ldap-domain`, payload);
    } catch (error: unknown) {
      addToast({ type: 'error', content: 'Failed to claim LDAP domain' });
      throw error;
    }
  };

  return {
    claimLDAPDomain,
  };
};

export default useClaimLDAPDomain;
